module.exports = __webpack_public_path__ + "assets/images/lectura.59b7906fa52f3f740079939f1c40b1fb.svg";